var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkShearIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 7.5V4.167H12.5M10.834 9.166l5-5M16.667 10.834V12.5a4.167 4.167 0 0 1-4.166 4.167h-5A4.167 4.167 0 0 1 3.334 12.5v-5a4.167 4.167 0 0 1 4.167-4.167h1.666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkShearIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LinkShearIcon.fc1c3fcc.svg";
export { ForwardRef as ReactComponent };